

export type AttributeObject = Record<string, unknown>;

const convertDataAttributesToObject = (attributes: DOMStringMap): AttributeObject => {
  const returnedObject = {} as AttributeObject;
  const keys = Object.keys(attributes);

  Object.values(attributes).forEach((value: string | undefined, idx) => {
    const key = keys[idx] as string;
    try {
      returnedObject[key] = JSON.parse(`${value}`);
    } catch (e) {
      returnedObject[key] = `${value}`;
    }
  });

  return returnedObject;
};

export default convertDataAttributesToObject;
